export default {"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12};